export default "__VITE_ASSET__e3c5ac07__"